import { gql } from '@apollo/client'

const UPDATE_BRAND_CURATION_TASK_STATUS_FLAG_MUTATION = gql`
  mutation updateBrandCurationTaskStatusFlagMutation(
    $id: ID!
    $data: StatusFlagsUpdateInput!
  ) {
    updateBrandCurationTaskStatusFlag(id: $id, data: $data) {
      id
      taskStatus
      isCurationDone
      isQaDone
      isQcDone
      isReopenedManually
    }
  }
`

export default UPDATE_BRAND_CURATION_TASK_STATUS_FLAG_MUTATION
